<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-10 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <h4 class="pt-4">ثبت نام نهایی</h4>
                <br/>
                <span class="sp-danger">نمره آزمون شما: 2</span>
                <div class="row mt-3 txt-bold">
                  <div class="col-12 col-md-6">
                    <h6>نام و نام خانوادگی: پوریا محمدی</h6>
                  </div>
                  <div class="col-12 col-md-6">
                    <h6>شماره تماس: 09351662628</h6>
                  </div>
                </div>
                <div class="row mt-3 txt-bold">
                  <div class="col-12 col-md-6">
                    <div class="col-12">
                      <label class="form-label">تاریخ تولد</label>
                    </div>
                    <div class="row cu-input">
                      <div class="col-12 col-md-4">
                        <select name="rooz" id="rooz" class="form-select">
                          <option value="">روز</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                          <option value="13">13</option>
                          <option value="14">14</option>
                          <option value="15">15</option>
                          <option value="16">16</option>
                          <option value="17">17</option>
                          <option value="18">18</option>
                          <option value="19">19</option>
                          <option value="20">20</option>
                          <option value="21">21</option>
                          <option value="22">22</option>
                          <option value="23">23</option>
                          <option value="24">24</option>
                          <option value="25">25</option>
                          <option value="26">26</option>
                          <option value="27">27</option>
                          <option value="28">28</option>
                          <option value="29">29</option>
                          <option value="30">30</option>
                          <option value="31">31</option>

                        </select>
                      </div>
                      <div class="col-12 col-md-4">
                        <select name="mah" id="mah" class="form-select">
                          <option value="">ماه</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>

                        </select>
                      </div>
                      <div class="col-12 col-md-4">
                        <select name="sal" id="sal" required="" class="form-select">
                          <option value="">سال</option>
                          <option value="1310">1310</option>
                          <option value="1311">1311</option>
                          <option value="1312">1312</option>
                          <option value="1313">1313</option>
                          <option value="1314">1314</option>
                          <option value="1315">1315</option>
                          <option value="1316">1316</option>
                          <option value="1317">1317</option>
                          <option value="1318">1318</option>
                          <option value="1319">1319</option>
                          <option value="1320">1320</option>
                          <option value="1321">1321</option>
                          <option value="1322">1322</option>
                          <option value="1323">1323</option>
                          <option value="1324">1324</option>
                          <option value="1325">1325</option>
                          <option value="1326">1326</option>
                          <option value="1327">1327</option>
                          <option value="1328">1328</option>
                          <option value="1329">1329</option>
                          <option value="1330">1330</option>
                          <option value="1331">1331</option>
                          <option value="1332">1332</option>
                          <option value="1333">1333</option>
                          <option value="1334">1334</option>
                          <option value="1335">1335</option>
                          <option value="1336">1336</option>
                          <option value="1337">1337</option>
                          <option value="1338">1338</option>
                          <option value="1339">1339</option>
                          <option value="1340">1340</option>
                          <option value="1341">1341</option>
                          <option value="1342">1342</option>
                          <option value="1343">1343</option>
                          <option value="1344">1344</option>
                          <option value="1345">1345</option>
                          <option value="1346">1346</option>
                          <option value="1347">1347</option>
                          <option value="1348">1348</option>
                          <option value="1349">1349</option>
                          <option value="1350">1350</option>
                          <option value="1351">1351</option>
                          <option value="1352">1352</option>
                          <option value="1353">1353</option>
                          <option value="1354">1354</option>
                          <option value="1355">1355</option>
                          <option value="1356">1356</option>
                          <option value="1357">1357</option>
                          <option value="1358">1358</option>
                          <option value="1359">1359</option>
                          <option value="1360">1360</option>
                          <option value="1361">1361</option>
                          <option value="1362">1362</option>
                          <option value="1363">1363</option>
                          <option value="1364">1364</option>
                          <option value="1365">1365</option>
                          <option value="1366">1366</option>
                          <option value="1367">1367</option>
                          <option value="1368">1368</option>
                          <option value="1369">1369</option>
                          <option value="1370">1370</option>
                          <option value="1371">1371</option>
                          <option value="1372">1372</option>
                          <option value="1373">1373</option>
                          <option value="1374">1374</option>
                          <option value="1375">1375</option>
                          <option value="1376">1376</option>
                          <option value="1377">1377</option>
                          <option value="1378">1378</option>
                          <option value="1379">1379</option>
                          <option value="1380">1380</option>
                          <option value="1381">1381</option>
                          <option value="1382">1382</option>
                          <option value="1383">1383</option>
                          <option value="1384">1384</option>
                          <option value="1385">1385</option>
                          <option value="1386">1386</option>
                          <option value="1387">1387</option>
                          <option value="1388">1388</option>
                          <option value="1389">1389</option>
                          <option value="1390">1390</option>
                          <option value="1391">1391</option>
                          <option value="1392">1392</option>
                          <option value="1393">1393</option>
                          <option value="1394">1394</option>
                          <option value="1395">1395</option>
                          <option value="1396">1396</option>
                          <option value="1397">1397</option>
                          <option value="1398">1398</option>

                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <label for="father_name" class="form-label">نام پدر</label>
                    <input type="text" class="form-control" id="father_name">
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="faith" class="form-label">دین</label>
                    <input type="text" class="form-control" id="faith">
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="religion" class="form-label">مذهب</label>
                    <input type="text" class="form-control" id="religion">
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="national_code" class="form-label">کد ملی</label>
                    <input type="number" class="form-control" id="national_code">
                  </div>
                  <div class="col-12 col-md-6 cu-input pt-4">
                    <label for="education" class="form-label">تحصیلات</label>
                    <select name="education" required="" class="form-select">
                      <option value=""></option>
                      <option value="بی سواد">بی سواد</option>
                      <option value="ابتدایی">ابتدایی</option>
                      <option value="سیکل">سیکل</option>
                      <option value="دیپلم">دیپلم</option>
                      <option value="فوق دیپلم">فوق دیپلم</option>
                      <option value="لیسانس">لیسانس</option>
                      <option value="فوق لیسانس">فوق لیسانس</option>
                      <option value="دکترا">دکترا</option>
                      <option value="حوزوی سطح 1">حوزوی سطح 1</option>
                      <option value="حوزوی سطح 2">حوزوی سطح 2</option>
                      <option value="حوزوی سطح 3">حوزوی سطح 3</option>
                      <option value="حوزوی سطح 4">حوزوی سطح 4</option>
                    </select>
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="field" class="form-label">رشته</label>
                    <input type="text" class="form-control" id="field">
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="marital_status" class="form-label">وضعیت تاهل</label>
                    <select name="marital_status" class="form-control" required>
                      <option value=""></option>
                      <option value="متاهل">متاهل</option>
                      <option value="مجرد">مجرد</option>
                    </select>
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="province" class="form-label">استان</label>
                    <select class="form-control province" name="province" id="province" required>
                      <option value=""></option>
                      <option value="سیستان و بلوچستان">سیستان و بلوچستان</option>
                      <option value="خراسان رضوی">خراسان رضوی</option>
                      <option value="آذربایجان شرقی">آذربایجان شرقی</option>
                      <option value="آذربایجان غربی">آذربایجان غربی</option>
                      <option value="اردبیل">اردبیل</option>
                      <option value="اصفهان">اصفهان</option>
                      <option value="البرز">البرز</option>
                      <option value="ایلام">ایلام</option>
                      <option value="بوشهر">بوشهر</option>
                      <option value="تهران">تهران</option>
                      <option value="چهارمحال و بختیاری">چهارمحال و بختیاری</option>
                      <option value="خراسان جنوبی">خراسان جنوبی</option>
                      <option value="خراسان شمالی">خراسان شمالی</option>
                      <option value="خوزستان">خوزستان</option>
                      <option value="زنجان">زنجان</option>
                      <option value="سمنان">سمنان</option>
                      <option value="سیستان و بلوچستان">سیستان و بلوچستان</option>
                      <option value="فارس">فارس</option>
                      <option value="قزوین">قزوین</option>
                      <option value="قم">قم</option>
                      <option value="کردستان">کردستان</option>
                      <option value="کرمان">کرمان</option>
                      <option value="کرمانشاه">کرمانشاه</option>
                      <option value="کهکیلویه و بویراحمد">کهگیلویه و بویراحمد</option>
                      <option value="گلستان">گلستان</option>
                      <option value="گیلان">گیلان</option>
                      <option value="لرستان">لرستان</option>
                      <option value="مازندران">مازندران</option>
                      <option value="مرکزی">مرکزی</option>
                      <option value="هرمزگان">هرمزگان</option>
                      <option value="همدان">همدان</option>
                      <option value="یزد">یزد</option>
                    </select>
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="city" class="form-label">شهر</label>
                    <select name="city" class="form-control" required>
                      <option value=""></option>
                      <option value="زرآباد">زرآباد</option>
                    </select>
                  </div>
                  <div class="col-12 pt-4">
                    <label>آدرس</label>
                    <textarea class="form-control" style="height: 100px;" required="" name="address" id="address"></textarea>
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="reagent_name" class="form-label">نام ونام خانوادگی معرف اول</label>
                    <input type="text" class="form-control" id="reagent_name">
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="reagent_phone" class="form-label">تلفن همراه معرف اول</label>
                    <input type="text" class="form-control" id="reagent_phone">
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="reagent_job" class="form-label">شغل معرف اول</label>
                    <input type="text" class="form-control" id="reagent_job">
                  </div>
                  <div class="col-12 pt-4">
                    <label class="form-label">در صورت داشتن معرف دوم</label>
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="reagent_name_2" class="form-label">نام ونام خانوادگی معرف دوم</label>
                    <input type="text" class="form-control" id="reagent_name_2">
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="reagent_phone_2" class="form-label">تلفن همراه معرف دوم</label>
                    <input type="text" class="form-control" id="reagent_phone_2">
                  </div>
                  <div class="col-12 col-md-6 pt-4">
                    <label for="reagent_job_2" class="form-label">شغل معرف دوم</label>
                    <input type="text" class="form-control" id="reagent_job_2">
                  </div>
                  <div class="col-12 pt-4">
                    <p>
                      در زمان بارگذاری تصاویر حجم تصویر را پایین بیاورید و در صورتی که در بارگذاری به مشکل خوردید مدارک را در ایتا به شماره
                      ارسال کنید.
                    </p>
                  </div>
                  <div class="col-12 pt-4">
                    <h6>تصویر کارت ملی یا صفحه اول شناسنامه (اجباری)</h6>
                    <div class="mb-3">
                      <label for="formFile" class="form-label">(حداکثر حجم یک مگابایت)</label>
                      <input class="form-control" type="file" id="formFile">
                    </div>
                  </div>
                  <div class="col-12 pt-4">
                    <div class="mb-3">
                      <label for="formFile" class="form-label">مدرک شناسایی از بسیج یا حوزه علمیه یا موسسه فرهنگی(حداکثر حجم یک مگابایت)</label>
                      <input class="form-control" type="file" id="formFile">
                    </div>
                  </div>
                  <div class="col-12 pt-4">
                    <div class="mb-3">
                      <label for="formFile" class="form-label">مدرک شناسایی از بسیج یا حوزه علمیه یا موسسه فرهنگی(حداکثر حجم یک مگابایت)</label>
                      <input class="form-control" type="file" id="formFile">
                    </div>
                  </div>
                </div>
                <br/>
                <RouterLink to="/final" class="bbot mx-auto">
                  ثبت
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompleteFormView"
}
</script>

<style scoped>

</style>